import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { DialogModal } from './dialog';
const DialogServiceContext = React.createContext(() => {
    throw new Error('Please ensure you register the dialog provider!');
});
export const useDialog = () => React.useContext(DialogServiceContext);
export const DialogServiceProvider = ({ children }) => {
    const [dialogState, setDialogState] = React.useState(null);
    const openConfirmation = (options) => {
        setDialogState(options);
    };
    const handleClose = () => {
        if (dialogState === null || dialogState === void 0 ? void 0 : dialogState.blocking) {
            return;
        }
        setDialogState(null);
    };
    const handleSubmit = () => {
        setDialogState(null);
    };
    return (_jsxs(_Fragment, { children: [_jsx(DialogServiceContext.Provider, { value: openConfirmation, children: children }), dialogState && (_jsx(DialogModal, Object.assign({ open: Boolean(dialogState), onSubmit: handleSubmit, onClose: handleClose }, dialogState)))] }));
};
//# sourceMappingURL=DialogService.js.map